"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumCustomerPortalTagIdToType = exports.SourgumCustomerPortalTagTypeToId = exports.SourgumCustomerPortalTagType = exports.SourgumCustomerPortalTagIds = exports.SourgumCustomerPortalTagTypes = exports.TagCategory = exports.TagCategoryLabels = exports.TagCategories = exports.InternalTicketRelatedEntity = exports.WaysteInternalTicketRelatedEntity = exports.WaysteInternalTicketRelatedEntityLabels = exports.WaysteInternalTicketRelatedEntities = exports.SourgumInternalTicketRelatedEntity = exports.SourgumInternalTicketRelatedEntityLabels = exports.SourgumInternalTicketRelatedEntities = exports.InternalTicketStatus = exports.InternalTicketStatusLabels = exports.InternalTicketStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InternalTicketStatuses = ['OPEN', 'IN_PROGRESS', 'SOLVED'];
exports.InternalTicketStatusLabels = {
    OPEN: 'To Do',
    IN_PROGRESS: 'In Progress',
    SOLVED: 'Done',
};
exports.InternalTicketStatus = typebox_1.Type.Union(exports.InternalTicketStatuses.map((value) => typebox_1.Type.Literal(value)));
// Get names from @alliance-disposal/wql folder src/types/index.ts -> allowedSearchSyncUpdateTypes
exports.SourgumInternalTicketRelatedEntities = [
    'sourgum-order',
    'sourgum-vendor',
    'sourgum-customer',
    'sourgum-service-grouping',
    'sourgum-service-order',
    'sourgum-lead',
    'sourgum-rfp',
    'operations-subscription',
    'sourgum-payout',
];
exports.SourgumInternalTicketRelatedEntityLabels = {
    'sourgum-order': 'Order',
    'sourgum-vendor': 'Vendor',
    'sourgum-customer': 'Customer',
    'sourgum-service-grouping': 'Service Grouping',
    'sourgum-service-order': 'Service Order',
    'sourgum-lead': 'Lead',
    'sourgum-rfp': 'RFP',
    'operations-subscription': 'Operations Subscription',
    'sourgum-payout': 'Payout',
};
exports.SourgumInternalTicketRelatedEntity = typebox_1.Type.Union(exports.SourgumInternalTicketRelatedEntities.map((value) => typebox_1.Type.Literal(value)));
exports.WaysteInternalTicketRelatedEntities = [
    'wayste-order',
    'wayste-customer',
    'wayste-commercial-subscription',
    'wayste-doc',
    'operations-subscription',
    'operations-order',
    'operations-task-group',
    'operations-task-group-dispatch',
    'operations-task-group-images',
];
exports.WaysteInternalTicketRelatedEntityLabels = {
    'wayste-order': 'Order',
    'wayste-customer': 'Customer',
    'wayste-commercial-subscription': 'Commercial Subscription',
    'wayste-doc': 'Document',
    'operations-subscription': 'Operations Subscription',
    'operations-order': 'Order',
    'operations-task-group': 'Operations Task Group',
    'operations-task-group-dispatch': 'Operations Task Group Dispatch',
    'operations-task-group-images': 'Operations Task Group Images',
};
exports.WaysteInternalTicketRelatedEntity = typebox_1.Type.Union(exports.WaysteInternalTicketRelatedEntities.map((value) => typebox_1.Type.Literal(value)));
exports.InternalTicketRelatedEntity = typebox_1.Type.Union([
    ...[...new Set([...exports.SourgumInternalTicketRelatedEntities, ...exports.WaysteInternalTicketRelatedEntities])].map((v) => typebox_1.Type.Literal(v)),
]);
exports.TagCategories = ['BILLING', 'DISPATCH', 'CUSTOMER_SERVICE', 'CUSTOMER', 'VENDOR', 'LEAD'];
exports.TagCategoryLabels = {
    BILLING: 'Billing',
    DISPATCH: 'Dispatch',
    CUSTOMER_SERVICE: 'Customer Service',
    CUSTOMER: 'Customer Specific',
    VENDOR: 'Vendor Specific',
    LEAD: 'Lead Specific',
};
exports.TagCategory = typebox_1.Type.Union(exports.TagCategories.map((value) => typebox_1.Type.Literal(value)));
exports.SourgumCustomerPortalTagTypes = ['INCIDENT_REPORT', 'CHANGE_REQUEST'];
exports.SourgumCustomerPortalTagIds = [
    '4d344504-4626-4e48-888f-671226ae73ad',
    '9bf6c825-57db-49cb-b4fe-21d551a08a70',
];
exports.SourgumCustomerPortalTagType = typebox_1.Type.Union(exports.SourgumCustomerPortalTagTypes.map((value) => typebox_1.Type.Literal(value)));
exports.SourgumCustomerPortalTagTypeToId = {
    INCIDENT_REPORT: '4d344504-4626-4e48-888f-671226ae73ad',
    CHANGE_REQUEST: '9bf6c825-57db-49cb-b4fe-21d551a08a70',
};
exports.SourgumCustomerPortalTagIdToType = {
    '4d344504-4626-4e48-888f-671226ae73ad': 'INCIDENT_REPORT',
    '9bf6c825-57db-49cb-b4fe-21d551a08a70': 'CHANGE_REQUEST',
};
//# sourceMappingURL=enums.js.map